import * as types from './actionTypes';

const initialState = {
  shiftLateProcess: [],
  shiftLateApprovalList:[],
  shiftLateApprovalEmployeeList:[],
  shiftLateCancelEmployeeList:[],
  shiftLateCancelData: [],
  viewPunchOrdersData: [],
  lateReport: [],
  consolidatedReport: [],
  loading: false,
  error: null,
  success: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    // ShiftLate
    case types.FETCH_TIME_DEDUCTION_SHIFT_LATE_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.FETCH_TIME_DEDUCTION_SHIFT_LATE_SUCCESS:
      return { ...state, loading: false, shiftLateProcess: action.payload.data, success: false };
    case types.FETCH_TIME_DEDUCTION_SHIFT_LATE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.SAVE_TIME_DEDUCTION_SHIFT_LATE_REQUEST:
      return { ...state, loading: true,error: null, success: false };
    case types.SAVE_TIME_DEDUCTION_SHIFT_LATE_SUCCESS:
      return { ...state, loading: false,success: true };
    case types.SAVE_TIME_DEDUCTION_SHIFT_LATE_FAILURE:
      return { ...state, loading: false,error: action.payload, success: false };

    // ShiftLateCancel
    case types.FETCH_TIME_DEDUCTION_SHIFT_LATE_CANCEL_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.FETCH_TIME_DEDUCTION_SHIFT_LATE_CANCEL_SUCCESS:
      return { ...state, loading: false, shiftLateCancelData: action.payload.data, success: false };
    case types.FETCH_TIME_DEDUCTION_SHIFT_LATE_CANCEL_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.SAVE_TIME_DEDUCTION_SHIFT_LATE_CANCEL_REQUEST:
      return { ...state, loading: true,error: null, success: false };
    case types.SAVE_TIME_DEDUCTION_SHIFT_LATE_CANCEL_SUCCESS:
      return { ...state, loading: false,success: true };
    case types.SAVE_TIME_DEDUCTION_SHIFT_LATE_CANCEL_FAILURE:
      return { ...state, loading: false,error: action.payload, success: false };

    // ViewPunchOrders
    case types.FETCH_VIEW_PUNCH_ORDERS_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.FETCH_VIEW_PUNCH_ORDERS_SUCCESS:
      return { ...state, loading: false, viewPunchOrdersData: action.payload.data, success: false };
    case types.FETCH_VIEW_PUNCH_ORDERS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

      case types.FETCH_SHIFT_LATE_APPROVAL_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.FETCH_SHIFT_LATE_APPROVAL_SUCCESS:
      return { ...state, loading: false, shiftLateApprovalList: action.payload.data, success: false };

    case types.FETCH_SHIFT_LATE_APPROVAL_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.SAVE_SHIFT_LATE_APPROVAL_REQUEST:
      return { ...state, loading: true,error: null, success: false };

    case types.SAVE_SHIFT_LATE_APPROVAL_SUCCESS:
      return { ...state, loading: false,success: true };

    case types.SAVE_SHIFT_LATE_APPROVAL_FAILURE:
      return { ...state, loading: false,error: action.payload, success: false };

    // Late Report
    case types.FETCH_LATE_REPORT_REQUEST:
      return { ...state, loading: true, error: null,success: false };
    case types.FETCH_LATE_REPORT_SUCCESS:
      return { ...state, loading: false, lateReport: action.payload,success: false };
    case types.FETCH_LATE_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload,success: false };

    // Consolidated Report
    case types.FETCH_LATE_CONSOLIDATED_REPORT_REQUEST:
      return { ...state, loading: true, error: null,success: false };
    case types.FETCH_LATE_CONSOLIDATED_REPORT_SUCCESS:
      return { ...state, loading: false, consolidatedReport: action.payload,success: false };
    case types.FETCH_LATE_CONSOLIDATED_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload,success: false };

    case types.FETCH_SHIFT_LATE_APPROVAL_EMPLOYEE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };
    case types.FETCH_SHIFT_LATE_APPROVAL_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        shiftLateApprovalEmployeeList: action.payload,
        success: false
      };
    case types.FETCH_SHIFT_LATE_APPROVAL_EMPLOYEE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false
      };
      
    case types.FETCH_SHIFT_LATE_CANCEL_EMPLOYEE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };
    case types.FETCH_SHIFT_LATE_CANCEL_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        shiftLateCancelEmployeeList: action.payload,
        success: false
      };
    case types.FETCH_SHIFT_LATE_CANCEL_EMPLOYEE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false
      };

    case types.RESET_TIME_DEDUCTION_SHIFT_LATE_CANCEL:
        return { ...initialState };
    default:
      return state;
  }
}
